import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './Nav.css';

const links = [
  { to: '/',           label: 'Inicio',   rune: '◈' },
  { to: '/pokedex',    label: 'Pokédex',  rune: '📖' },
  { to: '/lore',       label: 'Crónicas', rune: '📜' },
  { to: '/personajes', label: 'Sujetos',  rune: '⚔️'  },
  { to: '/mapa',       label: 'Mapa',     rune: '🗺️'  },
  { to: '/galeria',    label: 'Galería',  rune: '🖼️'  },
  { to: '/progreso',   label: 'Progreso', rune: '📊' },
];

export default function Nav() {
  const { pathname } = useLocation();
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [isAdmin,   setIsAdmin]   = useState(() => !!localStorage.getItem('admin_api_key'));

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-logo">
          <span className="nav-logo-rune">◈</span>
          <span className="nav-logo-text">Veltara</span>
        </Link>

        {/* Desktop links */}
        <ul className="nav-links">
          {links.map(({ to, label, rune }) => (
            <li key={to}>
              <Link to={to} className={`nav-link ${pathname === to ? 'active' : ''}`}>
                <span className="nav-link-rune">{rune}</span>
                <span className="nav-link-label">{label}</span>
                {pathname === to && (
                  <motion.div
                    className="nav-link-indicator"
                    layoutId="nav-indicator"
                    transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                  />
                )}
              </Link>
            </li>
          ))}
          {isAdmin && (
            <li>
              <Link to="/admin" className={`nav-link ${pathname === '/admin' ? 'active' : ''}`}>
                <span className="nav-link-rune">⚙️</span>
                <span className="nav-link-label">Admin</span>
                {pathname === '/admin' && (
                  <motion.div
                    className="nav-link-indicator"
                    layoutId="nav-indicator"
                    transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                  />
                )}
              </Link>
            </li>
          )}
        </ul>

        {/* Hamburger button */}
        <button
          className={`nav-hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="nav-mobile-menu"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
          >
            {[...links, ...(isAdmin ? [{ to: '/admin', label: 'Admin', rune: '⚙️' }] : [])].map(({ to, label, rune }, i) => (
              <motion.div
                key={to}
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.04, duration: 0.2 }}
              >
                <Link
                  to={to}
                  className={`nav-mobile-link${pathname === to ? ' active' : ''}`}
                >
                  <span className="nav-mobile-rune">{rune}</span>
                  <span>{label}</span>
                  {pathname === to && <span className="nav-mobile-dot">◈</span>}
                </Link>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
